module.exports = __webpack_public_path__ + "assets/935083545758570b0c566b1f19158adf.png";